import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Remet la page en haut à chaque changement de route — sauf si l'URL porte un
 * hash, auquel cas on rejoint la section visée. Sans ce cas particulier, les
 * liens du hub FAQ vers /multijoueur#faq atterrissaient en haut de page.
 *
 * Effet de layout, et non useEffect : depuis que les routes sont sous
 * ViewTransition (App.js), React diffère les effets passifs du commit de
 * navigation à la fin du fondu. Le défilement partirait donc 200 ms après le
 * clic, une fois la nouvelle page capturée à l'ancien décalage — le fondu
 * montrerait le bas de la nouvelle page, puis un saut sec vers le haut. Un
 * effet de layout s'exécute dans le commit, avant la capture, et le DOM de la
 * nouvelle route existe déjà : la cible d'un hash se trouve sans attendre une
 * frame.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useLayoutEffect(() => {
        if (hash) {
            const id = decodeURIComponent(hash.slice(1));
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "auto", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, hash]);

    return null;
}
